$(".certification-link").on("click", function(event){
	
	var imageURL = $(event.currentTarget).attr("data-imageurl");
	var pdfURL = $(event.currentTarget).attr("data-pdfurl");

	console.log(imageURL);
	console.log(pdfURL);

	var contentHTML = "";

	contentHTML +=	'<div class="certificate-modal-content">';
	contentHTML +=		'<div class="certificate-modal-image">';
	contentHTML +=			'<img src="' + imageURL +'" alt="Certificate">';
	contentHTML +=		'</div>';
	contentHTML +=		'<div class="certificate-modal-link">';
	contentHTML +=			'<a href="' + pdfURL + '">Download PDF</a>';
	contentHTML +=		'</div>';
	contentHTML +=	'</div>';

	$.fancybox({
		content: contentHTML,
	});

});